<div>
    <app-page-title [title]="'Select A Test Sitting'"></app-page-title>
    <app-selected-test-info
        [isCelpipOnline]="isWebDelivery"
        [isCELPIPTestSelection]="true"
        *ngIf="brandId === BrandEnum.CELPIP"
    ></app-selected-test-info>
    <div
        class="row"
        *ngIf="showSelectSittingsTypeOption"
    >
        <app-sitting-type-selection
            [isWebDelivery]="isWebDelivery"
            [showPrivateSittings]="showPrivateSittings"
            [brandId]="brandId"
            (toggle)="toggleTestType($event)"
        ></app-sitting-type-selection>
    </div>
</div>

<div
    class="row"
    *ngIf="showPrivateSittings && privateSittings"
>
    <div class="col-md-8">
        <app-sitting-list
            [sittings]="privateSittings"
            [isPrivate]="showPrivateSittings"
            [isWebDelivery]="isWebDelivery"
            [locationType]="locationType"
            [testTypeId]="testTypeId"
            (selectSitting)=finalizeSelectedSitting($event)
        >
        </app-sitting-list>
    </div>
</div>

<div *ngIf="!showPrivateSittings">
    <app-public-sittings
        [testTypeId]="testTypeId"
        [testPurposeId]="testPurposeId"
        [brandId]="brandId"
        (selectSitting)=finalizeSelectedSitting($event)
    ></app-public-sittings>
</div>

<app-modal
    #startingModal
    title="{{startingModalTitle}}"
    body="{{startingModalBody}}"
>
</app-modal>
